/*
 *    Copyright © 2026, Mirinae Corp.
 *
 *    Central on/off switches for Mirinae's own promotional offer overlays.
 *
 *    Every promo overlay should be gated on a flag from this file rather than by commenting
 *    out its mount site, so that what is running is visible in one place. Historically promos
 *    were retired by commenting the JSX where they were mounted, which left no single place to
 *    see what was live and let one campaign (the lessons 1.0 renewal offer) run unbounded for
 *    roughly 18 months.
 *
 *    Naming follows the existing ENABLE_* convention used elsewhere in the codebase, e.g.
 *    ENABLE_WIKINAE in explorer/containers/library/LibraryAsideContainer.js and
 *    ENABLE_DISCUSSION_BOARDS in lessons/modules/contexts/global.js.
 *
 *    To run a campaign: flip its flag to true, and give it an end date. None of these overlays
 *    has any built-in date gating -- once on, it stays on until someone turns it off by hand.
 */

// Full-screen "LESSON RENEWAL - SPECIAL OFFER - $44.99/year" modal on the Explorer app.
//   component: explorer/components/common/Lessons1dot0Promo.js
//   artwork:   public/assets/explorer/lessons-1-0-promo.png
//   shown to any user whose subscription is not 'active', once, then suppressed for 10 years
//   by the 'lessons10promoed' cookie. Ran from Mar 2025 with no end date; disabled Sep 2026.
export const ENABLE_LESSONS_1_0_PROMO = false;

// Seasonal offer overlays. Their mount sites in explorer/Explorer.js are commented out; these
// flags are the gate to use if any of them is ever revived, so that uncommenting a mount is
// not by itself enough to put a promo back in front of users.
//   components: explorer/components/common/{Xmas,HangulDay,Wikinae}PromoPopup.js
export const ENABLE_XMAS_PROMO = false;
export const ENABLE_HANGUL_DAY_PROMO = false;
export const ENABLE_WIKINAE_PROMO = false;

// One-time notice of the annual Pro price rise to $99.99/year (#74), on the Explorer app.
//   component: explorer/components/common/PriceChangeNotice.js
//   artwork:   public/assets/explorer/price-change-notice-{web,app}.jpg (the app one has no price
//              once John's artwork is in; until then both are sketch 2)
//   shown once to anyone whose subscription is not 'active', on the web and in the apps, except
//   on the landing page; then suppressed for 10 years by the 'priceChange2026Seen' cookie.
//   Turn it on BEFORE the price rises, while the current price can still be bought (the artwork
//   says "subscribe before the increase"), and off -- or swap the artwork -- when price plan 5.0
//   goes live (modules/define.js). Dates are John's to set. Not together with
//   ENABLE_LESSONS_1_0_PROMO: the two would open on top of each other.
export const ENABLE_PRICE_CHANGE_NOTICE = true;
